import { ReactNode } from 'react'

export const juItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>1. Items of Jointly Utilized Personal Information</h3>
        <p>
        Personal information such as name, address, telephone number, fax number, and e-mail address, etc., provided at the time of various inquiries, procedures, or submission of various certifications and official documents, and product purchase history.
        </p>
        <h3>2. The Scope of Jointly Utilizing Companies</h3>
        <p>
        The companies within the TRIAL Group and SU-PAY Co., Ltd. When providing personal information to group companies located overseas, necessary measures such as obtaining consent shall be taken in accordance with laws and regulations.
        </p>
        <h3>3. Person Responsible for Management of Jointly Utilized Personal Information</h3>
        <p>
        TRIAL Holdings, Inc.
        <br />
        1-12-2, Tanotsu, Higashi-ku, Fukuoka City
        <br />
        Operating Officer: Daigo Kobayashi
        </p>
      </>
    ),
    id: 'privacy1',
  }
]